import type { TEmployees } from '@crehana/compass.dashlets/my-team';

import {
  type EmployeeDetailsByLeaderFragment,
  type Get_Employee_List_By_Company_And_LeaderQueryVariables,
  useGet_Employee_List_By_Company_And_LeaderQuery,
} from './graphql/get-employee-list-by-company-boss.v5.generated';

export const useGetEmployeeListByCompanyAndBoss = (
  variables: Get_Employee_List_By_Company_And_LeaderQueryVariables,
  skip: boolean,
) => {
  const EmployeeList = useGet_Employee_List_By_Company_And_LeaderQuery({
    variables,
    context: {
      clientName: 'v5',
    },
    skip,
  });

  if (
    EmployeeList.data &&
    (EmployeeList.data?.talent.talentHCM.get_hcm_employees_by_company
      ?.__typename === 'ResponseIntegrityError' ||
      EmployeeList.data?.talent.talentHCM.get_hcm_employees_by_company
        ?.__typename === 'ResponseInternalError' ||
      EmployeeList.data?.talent.talentHCM.get_hcm_employees_by_company
        ?.__typename === 'ResponseValidationError' ||
      EmployeeList.error)
  ) {
    return {
      ...EmployeeList,
      error: EmployeeList.error?.message,
      data: null,
    };
  }

  if (
    EmployeeList.data &&
    EmployeeList.data?.talent.talentHCM.get_hcm_employees_by_company
      ?.__typename === 'HCMEmployeesByCompanyCustomConnection'
  ) {
    const rawData = EmployeeList.data?.talent.talentHCM
      .get_hcm_employees_by_company as EmployeeDetailsByLeaderFragment;

    const parsedData: TEmployees = {
      edges: rawData.edges.map(edge => ({
        node: {
          id: String(edge.node.id),
          avatar: {
            absolute_url: edge.node.avatar?.absolute_url || '',
            relative_url: edge.node.avatar?.relative_url || '',
          },
          person: {
            name: edge.node.person.name,
            last_name: edge.node.person.last_name || '',
            id: String(edge.node.person.id),
          },
          job: {
            name: edge.node.job?.name || '',
            id: String(edge.node.job?.id || 0),
          },
        },
      })),
    };

    return {
      ...EmployeeList,
      data: parsedData,
    };
  }

  return {
    ...EmployeeList,
    data: undefined,
    error: 'missing data',
  };
};
